module.exports = __webpack_public_path__ + "img/screen.b08e71fb.png";